<template>
  <div class="company-intro-page">
    <!-- 顶部操作栏 -->
    <div class="top-header">
      <h2>公司简介</h2>
      <template v-if="isDesktop">
        <el-radio-group v-model="currentLang" @change="handleLangChange">
          <el-radio-button v-for="item in languageList" :key="item.code" :label="item.code">{{ item.name }}</el-radio-button>
        </el-radio-group>
        <el-button type="primary" @click="handleEdit">编辑</el-button>
      </template>
      <template v-else>
        <van-radio-group v-model="currentLang" @change="handleLangChange">
          <van-radio v-for="item in languageList" :key="item.code" :label="item.code">{{ item.name }}</van-radio>
        </van-radio-group>
      </template>
    </div>
    
    <!-- 内容区域 -->
    <div class="content-container">
      <!-- 公司介绍卡片 -->
      
      <div class="intro-card" v-for="item in filteredCompanyIntroList" :key="item.id">
        <div class="card-content">
          <div v-if="item.content === ''" class="empty-state">
            <el-empty :description="currentLang === 'zh' ? '暂无公司介绍' : currentLang === 'en' ? 'No company introduction' : '회사 소개가 없습니다'" />
          </div>
          <div v-else class="ql-editor" v-html="item.content"></div>
        </div>
        <div class="card-footer">
          <span class="language-tag">{{ item.updated_at }}</span>
        </div>
      </div>
      
      <!-- 空状态 -->
      
    </div>
    
    <!-- 添加/编辑对话框 -->
    <template v-if="isDesktop">
      <el-drawer
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        size="70%"
        :before-close="handleClose"
      >
        <add-company-intro
          :companyIntro="editingItem"
          @save="handleSave"
          @cancel="handleClosePopup"
        />
      </el-drawer>
    </template>
    <template v-else>
      <van-popup
        v-model="dialogVisible"
        position="bottom"
        :round="true"
        :style="{ height: '80%' }"
        :close-on-click-overlay="false"
      >
        <div class="popup-header">
          <h3>{{ dialogTitle }}</h3>
          <van-icon name="cross" @click="handleClosePopup" />
        </div>
        <div class="popup-content">
          <add-company-intro
            :companyIntro="editingItem"
            @save="handleSave"
            @cancel="handleClosePopup"
          />
        </div>
      </van-popup>
    </template>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import AddCompanyIntro from './components/add.vue'
import { getLanguage } from '@/api/public'
import {getCompanyInfo} from "@/api/website"
import { Dialog } from 'vant'
export default {
  name: 'CompanyIntroductionPage',
  components: {
    AddCompanyIntro
  },
  data() {
    return {
      isDesktop: true,
      languageList: [],
      currentLang: 'zh',
      dialogVisible: false,
      dialogTitle: '',
      editingItem: null,
      companyIntroList: [
        
      ]
    }
  },
  mounted() {
    // this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)
    this.getLanguageList()
    this.getCompanyInfo()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize)
  },
  computed: {
    filteredCompanyIntroList() {
      return this.companyIntroList.filter(item => item.lang === this.currentLang)
    }
  },
  methods: {
    checkScreenSize() {
      this.isDesktop = window.innerWidth > 768
    },
    getCompanyInfo() {
      getCompanyInfo().then(res => {
        this.companyIntroList = res.data || []
      })
    },
    async getLanguageList() {
      try {
        const response = await getLanguage()
        this.languageList = response.data || []
      } catch (error) {
        console.error('获取语言列表失败:', error)
      }
    },
    handleAdd() {
      this.dialogTitle = '添加公司介绍'
      this.editingItem = null
      this.dialogVisible = true
    },
    handleEdit(item) {
      this.dialogTitle = '编辑公司介绍'
      this.editingItem = { ...item }
      this.dialogVisible = true
    },
    handleDelete(id) {
      this.$confirm('确定要删除吗？', '确定', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.companyIntroList = this.companyIntroList.filter(item => item.id !== id)
        this.$message.success('删除成功')
      }).catch(() => {})
    },
    handleSave(data) {
      // 处理三个语言版本的数据
      this.getCompanyInfo()
      this.$message.success('保存成功')
    },
    handleClose(done) {
      this.$confirm('确认关闭？').then(function() {
        done()
      }).catch(function() {})
    },
    handleClosePopup() {
      var vm = this
      Dialog.confirm({
        title: '提示',
        message: '确认关闭？',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function() {
        vm.dialogVisible = false
      }).catch(function() {})
    },
    handleLangChange() {
      // 语言切换逻辑
    },
    getLanguageName(lang) {
      const langMap = {
        zh: '中文',
        en: 'English',
        ko: '한국어'
      }
      return langMap[lang] || lang
    }
  }
}
</script>

<style scoped lang="scss">
.company-intro-page {
  width: 100%;
  padding: 20px;
}

.top-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.quill-content {
  // 确保 quill 样式正确应用到 v-html 生成的内容
  :deep(.ql-container) {
    font-size: 16px;
    line-height: 1.5;
  }
  
  :deep(.ql-editor) {
    min-height: 200px;
    padding: 10px;
  }
  
  :deep(p) {
    margin-bottom: 10px;
  }
  
  :deep(ul),
  :deep(ol) {
    margin-bottom: 10px;
    padding-left: 20px;
  }
  
  :deep(img) {
    max-width: 100%;
    height: auto;
  }
  
  :deep(h1),
  :deep(h2),
  :deep(h3),
  :deep(h4),
  :deep(h5),
  :deep(h6) {
    margin-top: 20px;
    margin-bottom: 10px;
    font-weight: bold;
  }
  
  :deep(blockquote) {
    border-left: 4px solid #ccc;
    padding-left: 10px;
    margin: 10px 0;
    font-style: italic;
  }
  
  :deep(pre) {
    background-color: #f5f5f5;
    padding: 10px;
    border-radius: 4px;
    overflow-x: auto;
  }
  
  :deep(code) {
    background-color: #f5f5f5;
    padding: 2px 4px;
    border-radius: 4px;
  }
}

.top-header {
  padding-bottom: 15px;
  border-bottom: 1px solid #e4e7ed;
}

.top-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.language-switcher {
  margin-bottom: 20px;
  text-align: right;
}

.content-container {
  min-height: 400px;
}

.intro-card {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f2f5;
}

.card-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.card-actions {
  display: flex;
  gap: 10px;
}

.card-content {
  margin-bottom: 15px;
}

.content-section {
  margin-bottom: 15px;
}

.content-section h4 {
  margin: 0 0 10px 0;
  font-size: 14px;
  font-weight: 500;
  color: #606266;
}

.content-section p {
  margin: 0;
  line-height: 1.6;
  color: #606266;
}

.content-section ul {
  margin: 0;
  padding-left: 20px;
}

.content-section li {
  margin-bottom: 5px;
  color: #606266;
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
  border-top: 1px solid #f0f2f5;
  font-size: 12px;
  color: #909399;
}

.language-tag {
  padding: 2px 8px;
  background-color: #ecf5ff;
  color: #409eff;
  border-radius: 10px;
}

.empty-state {
  text-align: center;
  padding: 60px 0;
  background-color: #f5f7fa;
  border-radius: 8px;
}

/* 移动端弹出框样式 */
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.popup-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.popup-content {
  padding: 16px;
  height: calc(100% - 60px);
  overflow-y: auto;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .company-intro-page {
    padding: 10px;
  }
  
  .top-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .language-switcher {
    text-align: left;
  }
  
  .intro-card {
    padding: 15px;
  }
}
</style>